<template>
  <select
    :value="value"
    @change="$emit('input', $event.target.value)"
  >
    <option
      v-for="(option, i) in options"
      :key="i"
      :value="option"
    >
      {{ option }}
    </option>
  </select>
</template>

<script>
	export default {
		props: {
			value: [String, Number],
			options: Array,
		},
	};
</script>

<style>
	select {
		padding: 10px;
		font: inherit;
		background: #FFFFFF;
		border: 1px solid #CECECE;
		outline: none;
	}
</style>